import React, { memo } from 'react';

import Styled from '@/components/atomic/molecules/utils/portals/desktop-menu-container/frosted-glass-bar/styled';

import { FrostedGlassBarProps } from './typings';

const FrostedGlassBar: React.FC<FrostedGlassBarProps> = ({ $height }) => (
	<Styled $height={$height} />
);

export default memo(FrostedGlassBar);
